<template>
  <ContactMessage v-if="disallowChurn" />
  <CancellationForm
    v-else
    v-model="formData"
  />
</template>

<script
  lang="ts"
  setup
>
import CancellationForm from './CancellationForm.vue';
import ContactMessage from './ContactMessage.vue';

const props = defineProps<{
  disallowChurn: boolean;
  modelValue: {
    otherSoftware: string;
    explanation: string;
    password: string;
  };
}>();

const emit = defineEmits(['update:modelValue']);

const formData = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  },
});
</script>
